import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button, ButtonGroup } from "@vds/buttons";
import { Link } from "react-router-dom";
import { createRole, fetchRequestDefinition } from "../../model/roleService";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Input } from "@vds/inputs";
import { useNavigate } from "react-router-dom";
import { CustomTable } from "../../global/components/Tables/CustomTable";
import { InlineCheckbox } from "../../global/utility/styledComponents";
import {
  RoleContainer,
  AddRoleContainerWithButtons,
  AddRoleHeading,
  SaveButton,
  BreadcrumbContainer,
  InputContainer,
  RoleInputWrapper,
} from "./Styles";

export const CreateRole = () => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const [requestDefinitionList, setRequestDefinitionList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedActions, setSelectedActions] = useState({});
  const [description, setDescription] = useState("");
  const [roleName, setRoleName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDefinitionList = async () => {
      const requestDefinitionList = await fetchRequestDefinition(activeSession); // Replace with your actual API endpoint
      setRequestDefinitionList(requestDefinitionList);
      setTableLoading(false);

      const initialActions = {};
      requestDefinitionList.forEach((item) => {
        initialActions[item.object] = {
          View: false,
          Create: false,
          Edit: false,
          Delete: false,
        };
      });
      setSelectedActions(initialActions);
    };
    setTableLoading(true);
    fetchDefinitionList();
  }, []);

  const handleCheckboxChange = (object, action) => {
    setSelectedActions((prevState) => ({
      ...prevState,
      [object]: {
        ...prevState[object],
        [action]: !prevState[object][action],
      },
    }));
  };

  const handleSave = async () => {
    const requestDefinitionSelected = Object.entries(selectedActions)
      .map(([object, actions]) => {
        const selected = Object.keys(actions).filter(
          (action) => actions[action]
        );
        return selected.length > 0 ? { object, actions: selected } : null;
      })
      .filter((item) => item !== null);
    try {
      setTableLoading(true);
      if (requestDefinitionSelected.length > 0) {
        await createRole(
          activeSession,
          roleName,
          description,
          requestDefinitionSelected
        );
      }

      navigate("/roles");
    } catch (error) {
      setTableLoading(false);
      return null;
    }
  };

  const renderedColumns = [
    {
      title: "Object",
      dataIndex: "object",
      key: "object",
    },
    {
      title: "View",
      key: "view",
      render: (text, record) => (
        <InlineCheckbox
          type="checkbox"
          checked={selectedActions[record.object]?.View || false}
          onChange={() => handleCheckboxChange(record.object, "View")}
        />
      ),
    },
    {
      title: "Create",
      key: "create",
      render: (text, record) => (
        <InlineCheckbox
          type="checkbox"
          checked={selectedActions[record.object]?.Create || false}
          onChange={() => handleCheckboxChange(record.object, "Create")}
        />
      ),
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <InlineCheckbox
          type="checkbox"
          checked={selectedActions[record.object]?.Edit || false}
          onChange={() => handleCheckboxChange(record.object, "Edit")}
        />
      ),
    },
    {
      title: "Delete",
      key: "delete",
      render: (text, record) => (
        <InlineCheckbox
          type="checkbox"
          checked={selectedActions[record.object]?.Delete || false}
          onChange={() => handleCheckboxChange(record.object, "Delete")}
        />
      ),
    },
  ];

  return (
    <>
      <BreadcrumbContainer>
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link
              data-testid="createRole_settingsLink"
              to="/settings"
              className="breadcrums-item_link"
            >
              Settings
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              data-testid="createRole_rolesLink"
              to="/roles"
              className="breadcrums-item_link"
            >
              Roles
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Create a Role</BreadcrumbItem>
        </Breadcrumbs>
      </BreadcrumbContainer>
      <br />

      <RoleContainer>
        <AddRoleContainerWithButtons>
          <AddRoleHeading>Create a Role</AddRoleHeading>
          <SaveButton>
            <ButtonGroup
              rowQuantity={{ mobile: 1, tablet: 1, desktop: 1 }}
              data={[
                {
                  children: "Save role",
                  size: "small",
                  use: "primary",
                  width: "auto",
                  "data-testid": "createRole_saveRoleButton",
                  onClick: () => {
                    handleSave();
                  },
                },
              ]}
            />
          </SaveButton>
        </AddRoleContainerWithButtons>
        <InputContainer>
          <RoleInputWrapper className="role-name-input">
            <Input
              type="text"
              label="Role name"
              readOnly={false}
              required={true}
              disabled={false}
              error={false}
              value={roleName}
              errorText="Enter a valid name."
              onChange={(e) => setRoleName(e.target.value)}
            />
          </RoleInputWrapper>
          <RoleInputWrapper className="role-description-input">
            <Input
              type="text"
              label="Role description"
              readOnly={false}
              required={true}
              disabled={false}
              error={false}
              value={description}
              errorText="Enter a valid description."
              onChange={(e) => setDescription(e.target.value)}
            />
          </RoleInputWrapper>
        </InputContainer>
      </RoleContainer>

      <CustomTable
        dataList={requestDefinitionList}
        tableLoading={tableLoading}
        pagination={true}
        renderedColumns={renderedColumns}
      />
    </>
  );
};

export default CreateRole;
